/* @flow */
export default function importExternal(url) {
  if (typeof globalThis.document === 'undefined') return Promise.resolve()
  return new Promise(resolve => {
    const script = globalThis.document.createElement('script')
    script.async = true
    script.src = url
    script.defer = true
    script.crossorigin = 'anonymous'

    function onLoad() {
      if (!this.readyState || this.readyState === 'complete') {
        script.onload = null
        script.onreadystatechange = null
        resolve()
      }
    }

    script.onload = onLoad
    script.onreadystatechange = onLoad

    const sibling = globalThis.document.getElementsByTagName('script')[0]
    if (sibling && sibling.parentNode) sibling.parentNode.insertBefore(script, sibling)
    else globalThis.document.head.appendChild(script)
  })
}
